export default __webpack_public_path__ + "static/android-bc4a479dbcd6fce04774c54612876f57.svg";